import useSWR from 'swr';
import { LeagueGroupFragment } from '@amf/shared/types/graphql';
import { LeagueTeamHomeOrAway } from '@amf/shared/data/League';
import { Response } from '@amf/shared/data/api/Response';
import { fromUnixTime } from 'date-fns';

const API_KEY = '/api/table';
const getCacheKey =
  (league: string, phase: string | null, homeOrAway: LeagueTeamHomeOrAway) => () => {
    if (!phase) return null;
    const params = new URLSearchParams({ league, phase });
    if (homeOrAway !== LeagueTeamHomeOrAway.all) params.append('homeOrAway', homeOrAway);
    return `${API_KEY}?${params.toString()}`;
  };

function useLeagueTable(
  league: string,
  homeOrAway: LeagueTeamHomeOrAway,
  phase: string | null = null,
) {
  const { data, error } = useSWR<Response<LeagueGroupFragment[]>>(
    getCacheKey(league, phase, homeOrAway),
  );
  return {
    error,
    table: data?.data,
    loading: !data && !error,
    updatedAt: data?.updatedAt ? fromUnixTime(data.updatedAt) : null,
  };
}

export default useLeagueTable;
